import { createMutation } from '@tanstack/svelte-query';
import { subscribeToNewsletter } from '../subscribeToNewsletter/subscribeToNewsletter';

export const createNewsletterMutation = () => {
	return createMutation(() => ({ mutationFn: subscribeToNewsletter }));
};
